import { IconChevronRight } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

type CardVariant = "item" | "vehicle" | "scanner";

interface RfidLinkCardProps {
  variant: CardVariant;
  label: string;
  path: string;
  icon: React.ReactNode;
  deviceType?: string;
}

const variantStyles = {
  item: {
    border: "border-[#b2f2bb]",
    bg: "bg-[#ebfbee]",
    hover: "hover:bg-[#d3f9d8]",
    text: "text-[#2b8a3e]",
  },
  vehicle: {
    border: "border-[#d0bfff]",
    bg: "bg-[#f3f0ff]",
    hover: "hover:bg-[#e5dbff]",
    text: "text-[#6741d9]",
  },
  scanner: {
    border: "border-[#fcc2d7]",
    bg: "bg-[#fff0f6]",
    hover: "hover:bg-[#ffdeeb]",
    text: "text-[#c2255c]",
  },
};

const RfidLinkCard = ({ variant, label, path, icon, deviceType }: RfidLinkCardProps) => {
  const navigate = useNavigate();
  const styles = variantStyles[variant];

  return (
    <div
      onClick={() => navigate(path)}
      className={`cursor-pointer border ${styles.border} ${styles.bg} ${styles.hover} rounded-lg px-3 py-1.5 transition-all duration-200`}
    >
      <div className={`flex justify-between items-center mb-1 pb-1 border-b ${styles.border} -mx-3 px-3`}>
        <div className="flex items-center gap-1">
          <div className={styles.text}>{icon}</div>
          {deviceType && (
            <span className={`text-[10px] ${styles.text} font-bold leading-[14px] flex items-center`}>
              {deviceType}
            </span>
          )}
        </div>
        <IconChevronRight size={14} className={styles.text} />
      </div>
      <div className={`break-words text-xs ${styles.text} font-bold`}>
        {label}
      </div>
    </div>
  );
};

export default RfidLinkCard;
